import {
  initialState,
  Actions,
  State,
  REORDER_CATEGORIES,
  REORDER_CATEGORIES_SUCCESS,
  REORDER_CATEGORIES_ERROR,
} from "../../types/category/reorder-categories";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case REORDER_CATEGORIES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case REORDER_CATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case REORDER_CATEGORIES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
